/* stylelint-disable no-descending-specificity */
import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from '@bijie/react-bnb';
import { Carousel } from 'antd';

import FlexBox from '../FlexBox';
import { Link } from '../../routes';
import { getLabel } from '../../utils/i18n';
import withI18n from '../../utils/withI18n';
import Icon from '../Icon';

const Container = styled(FlexBox)`
  a {
    text-decoration: none;
  }
`;

const BannerBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  position: relative;
`;

const BannerContentBox = styled(FlexBox)`
  width: 100%;
  background: url(${require('./banner.jpg')}) center center;
  background-size: cover;
  height: calc(100vh - 60px);
  @media screen and (max-height: 768px) {
    min-height: 559px;
  }
  > div {
    width: 1260px;
    height: auto;
    margin: 0 auto;
    text-align: center;
    padding-top: 200px;
    align-content: start;
    @media screen and (max-height:768px) {
      padding-top: 180px;
    }
    h3 {
      width: 100%;
      margin: 0;
      text-align: center;
      font-size: 70px;
      font-family: ${({ theme }) => theme.fontIBMExtraLight};
      font-weight: 300;
      color: #fff !important;
      line-height: 104px;
    }
    h4 {
      width: 100%;
      text-align: center;
      font-size: 54px;
      font-family: ${({ theme }) => theme.fontIBMExtraLight};
      font-weight: 300;
      color: #fff !important;
      line-height: 104px;
      margin: 0 0 30px 0;
      @media screen and (max-height:768px) {
        margin: 0 0 20px 0;
      }
    }
    .jobBtnBack {
      width: 100%;
      height: 50px;
      .jobBtn {
        height: 50px;
        display: block;
        margin: 0 auto;
        border-radius: 3px;
        background: linear-gradient(to right, #f0b90b, #fbda3c);
        font-size: 18px;
        font-weight: 500;
        color: rgba(33, 40, 51, 1);
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
`;

const AdvanceBox = styled(FlexBox)`
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    bottom: 60px;
    @media screen and (max-height:768px) {
      position: static;
      background: #fff;
      padding: 60px 0;
    }
    > div {
      width: 1260px;
      margin: 0 auto;
      display: flex;
      align-content: space-between;
      justify-content: flex-start;
      > div {
        width: 315px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding-right:70px;
        &:last-child{
          padding-right: 0;
        }
        h4 {
          margin-top: 20px;
          margin-bottom: 0;
          font-size: 16px;
          font-weight: 500;
          color: #fff !important;
          line-height: 20px;
          font-family: ${({ theme }) => theme.fontIBMMedium};
          @media screen and (max-height:768px) {
            color:#212833 !important;
          }
        }
        p {
          margin-top: 16px;
          margin-bottom: 0;
          text-align: center;
          font-size:12px;
          font-weight: 400;
          font-family: ${({ theme }) => theme.fontIBMRegular};
          color: rgba(255,255,255,0.6) !important;
          line-height: 15px;
          @media screen and (max-height:768px) {
            color:#48515d !important;
          }
        }
      }
    }
  }
`;

const BinanceLifeBox = styled(FlexBox)`
  width: 100%;
  background: #fafafaff;
`;
const BinanceLifeMainBox = styled(FlexBox)`
  width: 1260px;
  margin: 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h4 {
    margin-top: 100px;
    margin-bottom: 0;
    color: #212833 !important;
    display: block;
    height: 70px;
    font-size: 54px;
    font-family: ${({ theme }) => theme.fontIBMExtraLight};
    font-weight: 200;
    line-height: 70px;
  }
  p {
    text-align: center;
    margin-top: 25px;
    margin-bottom: 0;
    height: 40px;
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    font-weight: 400;
    color: #48515d !important;
    line-height: 24px;
  }
  .carouselTitle {
    &:nth-child(1) {
      display: block;
    }
    &:nth-child(2) {
      display: none;
    }
    &:nth-child(3) {
      display: none;
    }
  }
  .carouselText {
    &:nth-child(1) {
      display: block;
    }
    &:nth-child(2) {
      display: none;
    }
    &:nth-child(3) {
      display: none;
    }
  }
  div.binanceLife {
    width: 100%;
    margin-top: 100px;
    div {
      width: 100%;
      height: 436px;
    }
    img {
      width: 1260px;
      height: 436px;
    }
    .carouContr {
      height: 30px;
      width: 1060px;
      margin: 0 auto;
      margin-top: 53px;
      margin-bottom: 160px;
      > div {
        width: 30px;
        height: 30px;
        float: left;
        &:nth-child(1) {
          width: 75px;
          height: 28px;
          font-size: 20px;
          font-weight: bold;
          line-height: 28px;
          .currentPic {
            font-family: ${({ theme }) => theme.fontIBMRegular};
            color: rgba(33, 40, 51, 1);
          }
          .totalPic {
            font-family: ${({ theme }) => theme.fontIBMRegular};
            color: rgba(132, 142, 156, 1);
          }
        }
        &:nth-child(2) {
          width: 765px;
          margin-left: 80px;
          margin-right: 80px;
          > div {
            width: 255px;
            height: 2px;
            border-radius: 1px;
            float: left;
            margin-top: 13px;
          }
          .carouselLine {
            &:nth-child(1) {
              background: rgba(0, 0, 0, 1);
            }
            &:nth-child(2) {
              background: #d5d5d5;
            }
            &:nth-child(3) {
              background: #d5d5d5;
            }
          }
        }
        &:nth-child(3) {
          width: 60px;
          i {
            line-height: 30px;
            cursor: pointer;
            font-size: 12px;
            color: #d5d5d5;
            &:hover {
              color: #212833;
            }
          }
          .icon-jiantou1 {
            margin-left: 20px;
          }
        }
      }
    }
  }
`;

const AllJobsBox = styled(FlexBox)`
  width: 1260px;
  margin: 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h4 {
    font-size: 54px;
    font-family: ${({ theme }) => theme.fontIBMExtraLight};
    line-height: 70px;
    color: #212833 !important;
    margin-top: 120px;
    margin-bottom: 100px;
    font-weight: 200;
  }
  div.jobType {
    margin-top: 46px;
    width: 450px;
    height: 36px;
    justify-content: center;
    span {
      width: 140px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      border-radius: 18px;
      cursor: pointer;
      transition: background 0.5s;
      &:nth-child(1) {
        color: ${({ jobType }) => (jobType === 'category' ? 'white' : '#848E9C')};
        background: ${props => (props.jobType === 'category' ? '#212833' : '#EAECEF')};
      }
      &:nth-child(2) {
        margin-left: 20px;
        color: ${props => (props.jobType === 'category' ? '#848E9C' : 'white')};
        background: ${props => (props.jobType === 'category' ? '#EAECEF' : '#212833')};
      }
    }
  }
  div.jobContent {
    .jobs {
      width: 273px;
      height: 256px;
      background: #fff;
      border-radius: 10px;
      border: 1px solid #f6f6f6;
      padding-top: 30px;
      padding-left: 30px;
      margin-left: 55px;
      margin-top: 50px;
      font-family: ${({ theme }) => theme.fontIBMMedium};
      &:hover {
        box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
      }
      :nth-child(4n-3) {
        margin-left: 0;
      }
      :nth-child(-n + 4) {
        margin-top: 0;
      }
      position: relative;
      span {
        width: 155px;
        display: inline-block;
        font-size: 18px;
        font-weight: 500;
        color: rgba(72, 81, 93, 1);
        line-height: 23px;
      }
      img {
        width: 120px;
        height: 120px;
        position: absolute;
        right: 0;
        bottom: 0;
        color: #d8d8d8;
        font-size: 120px;
      }
    }
    .jobs.disabled_job {
      div {
        color: #848e9c;
        font-size: 18px;
      }
      cursor: not-allowed;
      &:hover {
        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
  div.jobMap {
    position: relative;
    padding-bottom: 120px;
    a {
      background: #f6d56d;
      padding: 8px 16px;
      border-radius: 3px;
      font-size: 16px;
      color: rgba(72, 81, 93, 1);
      line-height: 20px;
      position: absolute;
      &:hover {
        background: #f0b90b;
      }
    }
    .california {
      left: 111px;
      top: 182px;
    }
    .london {
      left: 333px;
      top: 90px;
    }
    .moscow {
      left: 530px;
      top: 30px;
    }
    .jersey {
      left: 457px;
      top: 145px;
    }
    .paris {
      right: 550px;
      top: 89px;
    }
    .berlin {
      right: 488px;
      top: 129px;
    }
    .malta {
      right: 643px;
      top: 210px;
    }
    .istanbul {
      right: 450px;
      top: 186px;
    }
    .kampala {
      bottom: 357px;
      left: 539px;
    }
    .india {
      right: 228px;
      top: 200px;
    }
    .vietNam {
      bottom: 396px;
      right: 244px;
    }
    .manila {
      right: 0px;
      top: 315px;
    }
    .singapore {
      right: 267px;
      top: 385px;
    }
    .asia {
      top: 150px;
      right: 141px;
    }
  }
`;

const BenefitsBox = styled(FlexBox)`
  width: 100%;
  background: #fafafa;
`;

const BenefitsBoxMain = styled.div`
  width: 1260px;
  margin: 0 auto;
  h4 {
    margin-top: 100px;
    margin-bottom: 0;
    width: 100%;
    text-align: center;
    height: 71px;
    font-size: 54px;
    font-family: ${({ theme }) => theme.fontIBMExtraLight};
    font-weight: 200;
    color: #212833 !important;
    line-height: 72px;
  }
  .benefitsContent {
    margin-top: 100px;
    margin-bottom: 180px;
    .benefits {
      width: 33.33%;
      /* height: 20px; */
      margin-bottom: 18px;
      padding-left: 80px;
      i {
        display: block;
        width: 8px;
        height: 8px;
        background: #f0b90b;
        border-radius: 4px;
        margin-top: 7px;
      }
      span {
        margin-left: 8px;
        max-width: 95%;
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6) !important;
        font-family: ${({ theme }) => theme.fontIBMRegular};
        line-height: 20px;
      }
    }
  }
`;

const DiscoveredBox = styled(FlexBox)`
  width: 100%;
  height: 420px;
  background: #0b0e11;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h4 {
    margin-top: 100px;
    margin-bottom: 0;
    height: 71px;
    font-size: 54px;
    font-weight: 200;
    font-family: ${({ theme }) => theme.fontIBMExtraLight};
    color: #fff !important;
    line-height: 72px;
  }
  p {
    max-width: 680px;
    text-align: center;
    margin-top: 25px;
    margin-bottom: 0;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    color: rgba(255, 255, 255, 0.6);
    line-height: 24px;
  }
  a {
    margin-top: 30px;
    margin-bottom: 0;
    height: 24px;
    font-size: 20px;
    font-weight: 400;
    color: rgba(240, 185, 11, 1);
    line-height: 24px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;

type Props = {
  locale: string,
  i18n: Object,
};

export default
@withI18n
class CareersPage extends Component<Props> {
  _binancePicSlide = React.createRef();

  static defaultProps = {
    locale: 'en',
    i18n: 'en',
  };

  constructor(props) {
    super(props);
    this.state = {
      jobType: 'category',
    };
  }

  _clickLeft = () => {
    this._binancePicSlide.current.slick.innerSlider.slickPrev();
  };

  _clickRight = () => {
    this._binancePicSlide.current.slick.innerSlider.slickNext();
  };

  _hoverLeftArr = () => {
    const hilightDom = document.getElementsByClassName('icon-jiantou')[0];
    const lowlightDom = document.getElementsByClassName('icon-jiantou2')[0];
    hilightDom.style.color = '#212833';
    lowlightDom.style.color = '#EAECEF';
  };

  _hoverRightArr = () => {
    const hilightDom = document.getElementsByClassName('icon-jiantou2')[0];
    const lowlightDom = document.getElementsByClassName('icon-jiantou')[0];
    hilightDom.style.color = '#212833';
    lowlightDom.style.color = '#EAECEF';
  };

  _afterChange = (curr: number) => {
    const dom = document.getElementsByClassName('currentPic')[0];
    dom.innerText = `0${Number(curr) + 1}`;

    const carouselLineDoms = document.getElementsByClassName('carouselLine');
    for (let i = 0; i < carouselLineDoms.length; i++) {
      carouselLineDoms[i].style.background = '#d5d5d5';
    }
    carouselLineDoms[curr].style.background = '#000';

    const carouselTitles = document.getElementsByClassName('carouselTitle');
    for (let j = 0; j < carouselTitles.length; j++) {
      carouselTitles[j].style.display = 'none';
    }
    carouselTitles[curr].style.display = 'block';

    const carouselTextDoms = document.getElementsByClassName('carouselText');
    for (let j = 0; j < carouselTextDoms.length; j++) {
      carouselTextDoms[j].style.display = 'none';
    }
    carouselTextDoms[curr].style.display = 'block';
  };

  viewMorePosition = () => {
    window.open('https://jobs.lever.co/binance', '_blank');
  };

  render() {
    const { i18n } = this.props;
    const { jobType } = this.state;
    return (
      <Container>
        <BannerBox>
          {/*
          <BannerHeadBox>
            <BannerHeadMainBox>
              <Link route="#" prefetch={true}>
                <a className="boldBanner">{ getLabel('About Binance', i18n) }</a>
              </Link>
              <Link route="#" prefetch={true}>
                <a>{ getLabel('About', i18n) }</a>
              </Link>
              <Link route="/en/career" prefetch={true}>
                <a className="currentLink">{ getLabel('Careers', i18n) }</a>
              </Link>
              <Link route="#" prefetch={true}>
                <a>{ getLabel('Ecosystem', i18n) }</a>
              </Link>
              <Link route="#" prefetch={true}>
                <a>{ getLabel('Press', i18n) }</a>
              </Link>
              <Link route="/en/community" prefetch={true}>
                <a>{ getLabel('community', i18n) }</a>
              </Link>
            </BannerHeadMainBox>
          </BannerHeadBox>
          */}
          <BannerContentBox>
            <div>
              <h3>{getLabel('exchange-career-careersAtBinance', i18n)}</h3>
              <h4>{getLabel('exchange-career-technology', i18n)}</h4>
              <div className="jobBtnBack">
                <Link>
                  <Button id="career-button-viewOpenPositions" className="jobBtn" type="primary" onClick={this.viewMorePosition}>
                    {getLabel('exchange-career-viewOpenPositions', i18n)}
                  </Button>
                </Link>
              </div>
            </div>
          </BannerContentBox>
          <AdvanceBox>
            <div>
              <FlexBox>
                <img width="80" height="80" src={require('./img/Integrity.svg')} alt="Integrity" />
                <h4>{getLabel('exchange-career-integrity', i18n)}</h4>
                <p>{getLabel('exchange-career-integrityContent', i18n)}</p>
              </FlexBox>
              <FlexBox>
                <img
                  width="80"
                  height="80"
                  src={require('./img/Freedom to innovate.svg')}
                  alt="Freedom to innovate"
                />
                <h4>{getLabel('exchange-career-freedomToInnovate', i18n)}</h4>
                <p>{getLabel('exchange-career-freedomInnovateContent', i18n)}</p>
              </FlexBox>
              <FlexBox>
                <img
                  width="80"
                  height="80"
                  src={require('./img/Result driven.svg')}
                  alt="Result driven"
                />
                <h4>{getLabel('exchange-career-resultsDriven', i18n)}</h4>
                <p>{getLabel('exchange-career-resultsDrivenContent', i18n)}</p>
              </FlexBox>
              <FlexBox>
                <img
                  width="80"
                  height="80"
                  src={require('./img/Product feedback.svg')}
                  alt="Product feedback"
                />
                <h4>{getLabel('exchange-career-clearCommunication', i18n)}</h4>
                <p>{getLabel('exchange-career-clearCommunicationContent', i18n)}</p>
              </FlexBox>
            </div>
          </AdvanceBox>
        </BannerBox>
        <BinanceLifeBox>
          <BinanceLifeMainBox>
            <div>
              <h4 className="carouselTitle">{getLabel('exchange-career-doWhatLove', i18n)}</h4>
              <h4 className="carouselTitle">
                {getLabel('exchange-career-doSomethingMeaningful', i18n)}
              </h4>
              <h4 className="carouselTitle">{getLabel('exchange-career-growWithBinance', i18n)}</h4>
            </div>
            <div>
              <p className="carouselText">
                {getLabel('exchange-career-secretToSuccess', i18n)}
                <br />
                {getLabel('exchange-career-proudToOwn', i18n)}
              </p>
              <p className="carouselText">
                {getLabel('exchange-career-ourVision', i18n)}
                <br />
                {getLabel('exchange-career-buildProductServices', i18n)}
              </p>
              <p className="carouselText">
                {getLabel('exchange-career-tackleChallengingBusiness', i18n)}
                <br />
                {getLabel('exchange-career-opportunitiesEndless', i18n)}
              </p>
            </div>
            <FlexBox className="binanceLife">
              <Carousel
                autoplay={true}
                dots={false}
                ref={this._binancePicSlide}
                afterChange={this._afterChange}
              >
                <img src={require('./binance life 1.jpg')} alt="1_img" />
                <img src={require('./binance life 2.jpg')} alt="2_img" />
                <img src={require('./binance life 3.jpg')} alt="3_img" />
              </Carousel>
              <div className="carouContr">
                <div>
                  <span className="currentPic">01</span>
                  <span className="totalPic"> / 03</span>
                </div>
                <div>
                  <div className="carouselLine" />
                  <div className="carouselLine" />
                  <div className="carouselLine" />
                </div>
                <div>
                  <Icon
                    type="jiantou"
                    style={{ marginRight: '5px' }}
                    onClick={this._clickLeft}
                    role="button"
                    tabIndex={0}
                    onKeyPress={this._clickLeft}
                  />
                  <Icon
                    type="jiantou2"
                    onClick={this._clickRight}
                    role="button"
                    tabIndex={-1}
                    onKeyPress={this._clickRight}
                  />
                </div>
              </div>
            </FlexBox>
          </BinanceLifeMainBox>
        </BinanceLifeBox>
        <AllJobsBox jobType={jobType}>
          <h4>{getLabel('exchange-career-chooseYourTeam', i18n)}</h4>
          <FlexBox className="jobContent">
            <a
              id="career-a-businessDevelopment"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Business%20Development"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-businessDevelopment', i18n)}</span>
              <img src={require('./img/Business Development.svg')} alt="Business Development.svg" />
            </a>
            <a
              id="career-a-communications"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Communications"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-communications', i18n)}</span>
              <img src={require('./img/Communications.svg')} alt="Communications.svg" />
            </a>
            <a
              id="career-a-customerSupport"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Customer%20Support"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-customerSupport', i18n)}</span>
              <img src={require('./img/Customer Support.svg')} alt="Customer Support.svg" />
            </a>
            <a
              id="career-a-dataAnalytics"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Data%20%26%20Analytics"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-dataAnalytics', i18n)}</span>
              <img src={require('./img/Data and analytics.svg')} alt="Data and analytics.svg" />
            </a>
            <a
              id="career-a-editorialVideo"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Editorial%20%26%20Video"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-editorialVideo', i18n)}</span>
              <img src={require('./img/Editorial and video.svg')} alt="Editorial and video.svg" />
            </a>

            <a
              id="career-a-engineering"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Engineering"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-engineering', i18n)}</span>
              <img src={require('./img/Engineering.svg')} alt="Engineering.svg" />
            </a>
            <a
              id="career-a-financeAdministration"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Finance%20%26%20Administration"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-financeAdministration', i18n)}</span>
              <img
                src={require('./img/Finance and Administration.svg')}
                alt="Finance and Administration.svg"
              />
            </a>
            <a
              id="career-a-legalCompliance"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Legal%20and%20Compliance"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-legalCompliance', i18n)}</span>
              <img src={require('./img/Legal and compliance.svg')} alt="Legal and compliance.svg" />
            </a>
            <a
              id="career-a-localMarketing"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Local%20Marketing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-localMarketing', i18n)}</span>
              <img src={require('./img/Local Marketing.svg')} alt="Local Marketing.svg" />
            </a>
            <a
              id="career-a-marketing"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Marketing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-marketing', i18n)}</span>
              <img src={require('./img/Marketing.svg')} alt="Marketing.svg" />
            </a>
            <a
              id="career-a-operations"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Operations"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-operations', i18n)}</span>
              <img src={require('./img/Operations.svg')} alt="Operations.svg" />
            </a>
            <a
              id="career-a-productDesign"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Product%20%26%20Design"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-productDesign', i18n)}</span>
              <img src={require('./img/Product and design.svg')} alt="Product and design.svg" />
            </a>
            <a
              id="career-a-quantitativeStrategy"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Quantitative%20Strategy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-quantitativeStrategy', i18n)}</span>
              <img
                src={require('./img/Quantitative Strategy.svg')}
                alt="Quantitative Strategy.svg"
              />
            </a>
            <a
              id="career-a-security"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Security"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-security', i18n)}</span>
              <img src={require('./img/Security.svg')} alt="Security.svg" />
            </a>
            <a
              id="career-a-talentAcquisition"
              className="jobs"
              href="https://jobs.lever.co/binance?department=Talent%20Acquisition"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{getLabel('exchange-career-talentAcquisition', i18n)}</span>
              <img src={require('./img/Talent Acquisition.svg')} alt="Talent Acquisition.svg" />
            </a>
            <a id="career-a-HR" className="jobs disabled_job">
              <span>{getLabel('exchange-career-HR', i18n)}</span>
              <img src={require('./img/hr_disabled.svg')} alt="HR.svg" />
              <div>{getLabel('exchange-career-currentlyNoOpenings', i18n)}</div>
            </a>
          </FlexBox>

          <h4>{getLabel('exchange-career-chooseYourLocation', i18n)}</h4>
          <div className="jobMap">
            <img width="1260" height="635" src={require('./world_map.svg')} alt="map.svg" />
            <a
              id="career-a-californiaUnitedStates"
              className="california"
              href="https://jobs.lever.co/binance?location=California"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-californiaUnitedStates', i18n)}
            </a>
            <a
              id="career-a-londonUnitedKingdom"
              className="london"
              href="https://jobs.lever.co/binance?location=London"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-londonUnitedKingdom', i18n)}
            </a>
            <a
              id="career-a-moscowRussia"
              className="moscow"
              href="https://jobs.lever.co/binance?location=Moscow"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-moscowRussia', i18n)}
            </a>
            <a
              id="career-a-jersey"
              className="jersey"
              href="https://jobs.lever.co/binance?location=Jersey"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-jersey', i18n)}
            </a>
            <a
              id="career-a-parisFrance"
              className="paris"
              href="https://jobs.lever.co/binance?location=Paris"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-parisFrance', i18n)}
            </a>
            <a
              id="career-a-berlinGermany"
              className="berlin"
              href="https://jobs.lever.co/binance?location=Berlin"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-berlinGermany', i18n)}
            </a>
            <a
              id="career-a-malta"
              className="malta"
              href="https://jobs.lever.co/binance?location=Malta"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-malta', i18n)}
            </a>
            <a
              id="career-a-istanbulTukey"
              className="istanbul"
              href="https://jobs.lever.co/binance?location=Istanbul"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-istanbulTukey', i18n)}
            </a>
            <a
              id="career-a-londonUnitedKingdom2"
              className="london"
              href="https://jobs.lever.co/binance?location=London"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-londonUnitedKingdom', i18n)}
            </a>
            <a
              id="career-a-moscowRussia2"
              className="moscow"
              href="https://jobs.lever.co/binance?location=Moscow"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-moscowRussia', i18n)}
            </a>
            <a
              id="career-a-jersey2"
              className="jersey"
              href="https://jobs.lever.co/binance?location=Jersey"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-jersey', i18n)}
            </a>
            <a
              id="career-a-parisFrance2"
              className="paris"
              href="https://jobs.lever.co/binance?location=Paris"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-parisFrance', i18n)}
            </a>
            <a
              id="career-a-berlinGermany2"
              className="berlin"
              href="https://jobs.lever.co/binance?location=Berlin"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-berlinGermany', i18n)}
            </a>
            <a
              id="career-a-malta2"
              className="malta"
              href="https://jobs.lever.co/binance?location=Malta"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-malta', i18n)}
            </a>
            <a
              id="career-a-istanbulTukey2"
              className="istanbul"
              href="https://jobs.lever.co/binance?location=Istanbul"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-istanbulTukey', i18n)}
            </a>
            <a
              id="career-a-kampalaUganda"
              className="kampala"
              href="https://jobs.lever.co/binance?location=Kampala%2C%20Uganda"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-kampalaUganda', i18n)}
            </a>
            <a
              id="career-a-newDelhiIndia"
              className="india"
              href="https://jobs.lever.co/binance?location=New%20Delhi"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-newDelhiIndia', i18n)}
            </a>
            <a
              id="career-a-newDelhiIndia2"
              className="india"
              href="https://jobs.lever.co/binance?location=New%20Delhi"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-newDelhiIndia', i18n)}
            </a>
            <a
              id="career-a-hoChiMinh"
              className="vietNam"
              href="https://jobs.lever.co/binance?location=Ho%20Chi%20Minh"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-hoChiMinh', i18n)}
            </a>
            <a
              id="career-a-manilaPhilippines"
              className="manila"
              href="https://jobs.lever.co/binance?location=Manila"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-manilaPhilippines', i18n)}
            </a>
            <a
              id="career-a-singapore"
              className="singapore"
              href="https://jobs.lever.co/binance?location=Singapore"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-singapore', i18n)}
            </a>
            <a
              id="career-a-asia"
              className="asia"
              href="https://jobs.lever.co/binance?location=Asia"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-asia', i18n)}
            </a>
            <a
              id="career-a-manilaPhilippines2"
              className="manila"
              href="https://jobs.lever.co/binance?location=Manila"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-manilaPhilippines', i18n)}
            </a>
            <a
              id="career-a-singapore2"
              className="singapore"
              href="https://jobs.lever.co/binance?location=Singapore"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-singapore', i18n)}
            </a>
            <a
              id="career-a-asia2"
              className="asia"
              href="https://jobs.lever.co/binance?location=Asia"
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel('exchange-career-asia', i18n)}
            </a>
          </div>
        </AllJobsBox>

        <BenefitsBox>
          <BenefitsBoxMain>
            <h4>{getLabel('exchange-career-benefits', i18n)}</h4>
            <FlexBox className="benefitsContent">
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-hugeImpactCompany', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-competitiveSalaryBenefits', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-paidInCrypto', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-resultsDrivenMeritocracy', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-flexibleWorkHours', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-topTier', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-relocationSupport', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-companySponsoredHolidays', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-freeLanguageClasses', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-regularActivities', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-internationalTransfersMidCareer', i18n)}</span>
              </FlexBox>
              <FlexBox className="benefits">
                <i />
                <span>{getLabel('exchange-career-andMore', i18n)}...</span>
              </FlexBox>
            </FlexBox>
          </BenefitsBoxMain>
        </BenefitsBox>
        <DiscoveredBox>
          <h4>{getLabel('exchange-career-getDiscovered', i18n)}</h4>
          <p>{getLabel('exchange-career-cantFind', i18n)}</p>
          <a id="career-a-contactHRNow" href="mailto:hr@binance.com">{getLabel('exchange-career-contactHRNow', i18n)} →</a>
        </DiscoveredBox>
      </Container>
    );
  }
}
